/** Same contact as B2B Telegram deep link (+380982204411), digits only for wa.me */
export const B2B_MESSENGER_PHONE = '380982204411';

/** Allowed distance-to-connection-point values (meters) on B2B location lead form */
export const B2B_DISTANCE_METER_OPTIONS = [5, 10, 30, 50, 70, 100, 150, 200, 300];

/** Search radius around a map point for LOOKING (Шукаю локацію) submissions, km */
export const B2B_REGION_RADIUS_KM_OPTIONS = [1, 10, 25, 50, 75, 100];
export const B2B_REGION_RADIUS_KM_DEFAULT = 25;

export function formatB2bRegionRadiusKm(radiusKm, t) {
  const n = Number(radiusKm);
  if (!Number.isFinite(n)) return '';
  return t('b2bLeadFormRegionRadiusValue', { value: n });
}

export function formatB2bDistanceMeters(meters, t) {
  const n = Number(meters);
  if (!Number.isFinite(n)) return '';
  if (n === 5) return t('b2bLeadFormDistanceUpTo5');
  return `${n} m`;
}

export function buildGoogleMapsPointUrl(lat, lng) {
  return `https://www.google.com/maps?q=${Number(lat).toFixed(5)},${Number(lng).toFixed(5)}`;
}

export function formatB2bLocationLine(index, label, lat, lng) {
  return `${index + 1}. ${label}\n${buildGoogleMapsPointUrl(lat, lng)}`;
}

export function buildB2bTelegramUrl(message) {
  return `https://t.me/+${B2B_MESSENGER_PHONE}?text=${encodeURIComponent(message)}`;
}

export function buildB2bWhatsAppUrl(message) {
  return `https://wa.me/${B2B_MESSENGER_PHONE}?text=${encodeURIComponent(message)}`;
}

/** Lead kind stored by the feedback service. */
export function b2bLeadKind(formType, titleKey) {
  if (formType === 'proposeLocation') return 'propose_location';
  if (formType === 'lookingForLocation') return 'looking_for_location';
  if (titleKey === 'b2bAccordionServiceRequest') return 'service';
  if (titleKey === 'b2bConsultRdnBtn') return 'consult_rdn';
  return 'connect';
}
